<div class="container-fluid" *ngIf="!editingForm">
  <div class="row col-md-12 border p-4 bg-page">
    <div class="col-md-12 page-heading pr-0">
      <h4>I-9 Form | Section-1</h4>
      <div class="document-warning d-inline-block align-middle mr-2"></div> <p class="text-danger d-inline-block">Any changes you make in this form will be updated in the profile section.</p>
      <button type="button" *ngIf="!isEdit" [disabled]="!isEditEnabled"
            (click)="handleEdit()"
            class="float-right im-btn im-btn-with-icon im-btn-outline-primary pull-right button_whitebg ">
            Edit <span class="ml-2"><i class="fa fa-pencil"></i></span></button>
    </div>
  <div class="bg-white w-100 mt-4">
    <!-- <app-beneficiary-details-readonly [beneSignature]="beneSignature" [section1Info]="I9BeneficiaryDetails"></app-beneficiary-details-readonly>    -->
    <app-i9-beneficiary-details [beneSignature]="beneSignature" [isEdit]="isEdit" [section1Info]="I9BeneficiaryDetails"></app-i9-beneficiary-details> 
    <app-i9-form-details [isEdit]="isEdit"></app-i9-form-details>
    
    <div class="row border-bottom-dashed m-2"></div>
    
    <div class="row m-2">
      <div class="col-12">
        <label class="main-label">Let us know if you have used Preparer or translator to help you fill this form</label>
      </div>
     </div>
     <div class="row border-bottom-dashed m-2">    
        <div class="col-12 mt-1">
          <p-radioButton name="translator" [disabled] = "!isEdit" value="0" label="I did not use a preparer or translator" [(ngModel)]="isPreparer"></p-radioButton>
          
        </div>
        <div class="col-12 mb-4 mt-2">
          <p-radioButton name="translator" [disabled] = "!isEdit" value="1" label="A Preparer or translator assisted me in completing Section 1 for filling the I-9 Form" [(ngModel)]="isPreparer"></p-radioButton>
          
        </div>
      </div>
     <app-i9-preparer-info *ngIf="isPreparer === '1'" [isEdit]="isEdit"></app-i9-preparer-info>
    
    <div class="row">
      <div>
        <p-checkbox  [disabled]="!isEdit" name="agreeCheckbox" binary="true" inputId="agreeCheckbox" 
            [(ngModel)]="agreeCheckboxSelection" class="align-middle ml-4 mr-1"></p-checkbox>           
          </div>
      <div class="col-8">      
        <label>I Agree - I attest, under penalty of perjury, that (1) I have examined the documentation presented by the above-named employee, (2) the above-listed documentation appears to be genuine and to relate to the employee named, and (3) to the best of my knowledge, the employee is authorized to work in the United States.</label>
        <p-button type="button" (click)="showNotice()" label="Anti-discrimination notice" styleClass="p-button-link"></p-button>
      </div>
    </div>

    <div class="row border-bottom-dashed m-2"></div>
       <div class="row p-3"> 
         <div class="border-right pr-4">
          <button pButton class="ml-2" [disabled]="!isEdit || !agreeCheckboxSelection" (click)="submitI9Section1()">SUBMIT</button>
        </div>
          <button pButton class="p-button-outlined rounded ml-4" (click)="saveI9Section1()" [disabled]="!isEdit || !agreeCheckboxSelection">SAVE</button>
          <button pButton class="p-button-secondary ml-4" (click)="cancelI9()">CANCEL</button>
       </div>
  </div>
  </div>

  <p-dialog header="Anti-discrimination notice" [(visible)]="displayNotice" [modal]="true" [responsive]="true"
    [style]="{width: '800px', minWidth: '200px', height:'250px'}" [minY]="70" [maximizable]="false" [baseZIndex]="60000">
    <div [innerHTML]="antiDiscriminatoryData | keepHtml"></div>
</p-dialog>

